import { createApp } from 'vue'
import 'normalize.css'
import './assets/css/index.less'
import { globalRegister } from './global'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/resize'
import useUserStore from './store/modules/user'

import 'default-passive-events'

createApp(App).use(store).use(router).use(globalRegister).mount('#app')

const userStore = useUserStore()
userStore.loadLocalLogin()
